// Auto-generado por @xone-web/staticweb a partir de LoginColl.xne.
// NO EDITAR: se regenera en cada build.
// Eventos lifecycle + custom + sintéticos (onclick/onchange por prop).

import type { XoneAPI } from "../xone-api";
import type { LoginCollFields } from "./LoginColl.types";
export async function beforeEdit(api: XoneAPI<LoginCollFields>): Promise<unknown> {
    const { self, This, ThisDataColl, ui, appData, $http, crypto, Bundle, console } = api;
    void self; void This; void ThisDataColl; void ui; void appData; void $http; void crypto; void Bundle; void console;
    
    LoginColl_beforeEdit(self);
}
export async function aceptarLogin(api: XoneAPI<LoginCollFields>): Promise<unknown> {
    const { self, This, ThisDataColl, ui, appData, $http, crypto, Bundle, console } = api;
    void self; void This; void ThisDataColl; void ui; void appData; void $http; void crypto; void Bundle; void console;
    
    LoginColl_aceptarLogin(self);
}
export async function onback(api: XoneAPI<LoginCollFields>): Promise<unknown> {
    const { self, This, ThisDataColl, ui, appData, $http, crypto, Bundle, console } = api;
    void self; void This; void ThisDataColl; void ui; void appData; void $http; void crypto; void Bundle; void console;
    
    LoginColl_onBack(self);
}